import React, { FC } from 'react';
import { DynamicExteriorImagePreviewProps } from './';
import { useSelector } from 'react-redux';
import UIDuck from '../../redux/commonDucks/ui.duck';
import { ImageViewType } from '../../constants/enums';
import {useRouter} from "next/router";
import routes from "../../constants/routes";

export const DynamicExteriorImagePreviewTemplate: FC<DynamicExteriorImagePreviewProps> = ({
    className,
    imageUrl
}) => {
    const router = useRouter();

    const imageViewType = useSelector((state) => UIDuck.getOwnState(state).imageViewType);

    return (
        <div
            className={`${className} carImageWrap ${imageViewType === ImageViewType.INTERIOR ? 'withoutMaxWidth' : ''} ${router.pathname?.includes(routes.BASKET) ? 'isBasket' : ''}`}
        >
            <img className={`${router.pathname?.includes(routes.BASKET) ? 'withoutCover' : ''}`} src={imageUrl} />
        </div>
    );
};
